export const MAX_OFFER_AMOUNT: number = 1000000000;
